import { render, staticRenderFns } from "./BarLocationToggle.vue?vue&type=template&id=5e4819fa&"
import script from "./BarLocationToggle.vue?vue&type=script&lang=js&"
export * from "./BarLocationToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports